import React, { createContext } from 'react';

import { en } from './en';
import type { UITranslations } from './types';

export const UITextContext = createContext<UITranslations>(en);
UITextContext.displayName = 'UITextContext';

export interface UITextProviderProps {
    value: UITranslations;
    children: React.ReactNode;
}

export const UITextProvider: React.FC<UITextProviderProps> = ({ value, children }) => (
    <UITextContext.Provider value={value}>{children}</UITextContext.Provider>
);
